import { AxiosRequestConfig } from 'axios';

import { KeyResultAdd } from '../../../modules/okrs/manageObjectives/create/keyResults/CreateKeyResults';
import { okrApi } from '../../../services/ApiController';
import { KeyResultI } from '../keyResultStream/interfaces';
import { getUrlFromObject } from '../../../utils';
import { AsyncAction } from '../../../services/apiMiddleware';

import {
  createKeyResultTypes,
  deleteKeyResultTypes,
  editKeyResultTypes,
  fetchKeyResultsTypes,
  updateKeyResultType,
} from './actionTypes';

export const createKeyResult = (objectiveId: string, keyResult: KeyResultAdd) => ({
  types: createKeyResultTypes,
  callAPI: () => createKeyResultCall(objectiveId, keyResult),
});

export const editKeyResult = (keyResult: KeyResultI) => ({
  types: editKeyResultTypes,
  callAPI: () =>
    okrApi.put(`keyresults/${keyResult.id}`, {
      ...keyResult,
      owners: keyResult.owners.map(owner => owner.uuid),
    }),
});

export const deleteKeyResult = (keyResultId: string) => ({
  types: deleteKeyResultTypes,
  callAPI: () => okrApi.delete(`keyresults/${keyResultId}`),
  payload: { keyResultId },
});

export interface KeyResultUpdate {
  progress: number;
  comment?: string;
}

export function updateKeyResultAction(keyResultId: string, updateObj: KeyResultUpdate): AsyncAction {
  return {
    types: updateKeyResultType,
    callAPI: () => okrApi.put(`keyresults/${keyResultId}/progress`, updateObj),
    payload: updateObj,
  };
}

export const createKeyResultCall = (objectiveId: string, keyResult: KeyResultAdd) =>
  okrApi.post('keyresults', {
    objective_id: objectiveId,
    name: { en_US: keyResult.name },
    min: +keyResult.startValue,
    max: +keyResult.targetValue,
    progress: +keyResult.startValue,
    owners: keyResult.owners.map(owner => owner.id),
    weighting: keyResult.weighting,
  });

export enum KeyResultFilterTypes {
  Stream = 'filter.stream',
  Owner = 'filter.owner',
}

export interface KeyResultQueryI {
  [KeyResultFilterTypes.Stream]?: string;
  [KeyResultFilterTypes.Owner]?: string[];
}

export const fetchKeyResults = (
  objectiveId: string,
  query?: KeyResultQueryI,
  config?: AxiosRequestConfig,
) => {
  const queryStr = getUrlFromObject({ ...query, ['filter.objective']: objectiveId });
  return {
    types: fetchKeyResultsTypes,
    callAPI: () => okrApi.get(`/keyresults${queryStr}`, config),
  };
};
